@use "variables" as *;

.segment {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  box-sizing: border-box;
  overflow: auto;
  box-shadow: inset 0 0 32px 0 #000;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    top: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
  &:hover {
    border-style: double;
    border-width: 2px;
  }
}

.hoverButton {
  width: 40px !important;
  height: 40px !important;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonRadius {
  border-radius: 40px !important;
}

.backgroundImage {
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
  width: 100%;
}

.albumsContainer {
  position: relative;
  flex-shrink: 0;
}

.albumsDiv {
  position: relative;
  display: flex;
}

.albumContainerHorizontal {
  position: relative;
  display: flex;
  height: 100%;
  align-items: flex-end;
  flex-shrink: 0;
}

.albumContainerVertical {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  flex-shrink: 0;
}

.tooltipDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $spacing-s;
  text-align: center;
}

.tooltipAlbumName {
  font-size: $fontSize-m;
  font-weight: bold;
  white-space: pre-wrap;
}

.tooltipArtistName {
  font-size: $fontSize-s;
  font-weight: normal;
  white-space: pre-wrap;
}

.tooltipSubtitle {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
}

.loadingIndicator {
  display: block;
  margin: auto;
}
